class ProductTester {
  constructor(product, color, locale) {
    this.product = product
    this.color = color
    this.localeSplit = locale.split('-')
    this.localeParsed = locale
    this.metafieldsParsed = JSON.parse(product?.metafield?.value)
  }

  productExist() {
    return typeof this.product !== 'undefined' && this.product !== null
  }

  colorExist() {
    return !!this.product.options.filter((option) => {
      return option.values.includes(this.color)
    })?.length
  }

  metafieldsExist() {
    return !!this.metafieldsParsed
  }

  metafieldsLangExist() {
    return !!this.metafieldsParsed?.[this.localeParsed]
  }

  metafieldsColorExist() {
    return !!this.metafieldsParsed?.[this.localeParsed]?.colors?.[this.color]
  }
}

module.exports = ProductTester
